import DataLoader from "../Utlis/DataLoader";

async function Search(query) {
  try {
    const result = await DataLoader({
      Path: `/api/v1/posts/search?query=${query}`,
      Type: 'get'
    });
    return result;
  } catch (error) {
    throw error; 
  }
}

export default Search;
